import React, { useState } from 'react';
import cn from 'classnames';
import { useTrans } from 'utils/localisation';
import { Grid, GridItem } from 'components/UI/Grid';
import LazyImage from 'components/UI/LazyImage';
import Markup from 'components/Markup';
import * as styles from './icons.module.scss';

export function Component({ content, className }) {
  const [showPopup, setShowPopup] = useState(false);
  const t = useTrans(['common']);

  return (
    <div className={cn(className, styles.wrapper)}>
      <Grid xsm={{ cols: 2 }} sm={{ cols: 2 }} md={{ cols: 4 }} lg={{ cols: 4 }} xl={{ cols: 4 }}>
        {content.map(({ icon, label, sub, additionalSub }) => (
          <GridItem key={label}>
            {icon && <LazyImage src={icon} alt={label} className={styles.icon} />}
            <p className={styles.itemName}>{label}</p>
            <Markup className={styles.itemDescription}>{sub}</Markup>
            {additionalSub && (
              <div className={styles.additional}>
                <button
                  className={cn(styles.additionalButton, showPopup && styles.hide)}
                  onClick={() => setShowPopup(!showPopup)}
                >
                  {showPopup ? t('hideAll') : t('viewAll')}
                </button>
                <div className={cn(styles.additionalPopup, showPopup && styles.visible)}>
                  {additionalSub.map(({ title, description }) => (
                    <div key={title} className={styles.additionalSection}>
                      {title && <p>{title}</p>}
                      <p>{description}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </GridItem>
        ))}
      </Grid>
    </div>
  );
}
